/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetConfig200ResponseTillsCashInner } from './GetConfig200ResponseTillsCashInner';
import {
    GetConfig200ResponseTillsCashInnerFromJSON,
    GetConfig200ResponseTillsCashInnerFromJSONTyped,
    GetConfig200ResponseTillsCashInnerToJSON,
    GetConfig200ResponseTillsCashInnerToJSONTyped,
} from './GetConfig200ResponseTillsCashInner';

/**
 * 
 * @export
 * @interface GetConfig200ResponseTills
 */
export interface GetConfig200ResponseTills {
    /**
     * 
     * @type {Array<GetConfig200ResponseTillsCashInner>}
     * @memberof GetConfig200ResponseTills
     */
    cash: Array<GetConfig200ResponseTillsCashInner>;
}

/**
 * Check if a given object implements the GetConfig200ResponseTills interface.
 */
export function instanceOfGetConfig200ResponseTills(value: object): value is GetConfig200ResponseTills {
    if (!('cash' in value) || value['cash'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseTillsFromJSON(json: any): GetConfig200ResponseTills {
    return GetConfig200ResponseTillsFromJSONTyped(json, false);
}

export function GetConfig200ResponseTillsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseTills {
    if (json == null) {
        return json;
    }
    return {
        
        'cash': ((json['cash'] as Array<any>).map(GetConfig200ResponseTillsCashInnerFromJSON)),
    };
}

export function GetConfig200ResponseTillsToJSON(json: any): GetConfig200ResponseTills {
    return GetConfig200ResponseTillsToJSONTyped(json, false);
}

export function GetConfig200ResponseTillsToJSONTyped(value?: GetConfig200ResponseTills | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cash': ((value['cash'] as Array<any>).map(GetConfig200ResponseTillsCashInnerToJSON)),
    };
}

